import { Component, Input, ElementRef, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import type { PatientLabelModel } from './patient-label.model';
import * as JsBarcodeLib from 'jsbarcode';

const JsBarcode = (JsBarcodeLib as { default?: unknown }).default ?? JsBarcodeLib;

@Component({
  selector: 'app-patient-label-print',
  standalone: false,
  templateUrl: './patient-label-print.component.html',
  styleUrl: './patient-label-print.component.scss'
})
export class PatientLabelPrintComponent implements AfterViewInit, OnChanges {
  @Input() patient: PatientLabelModel | null = null;

  @ViewChild('barcodeEl') barcodeEl?: ElementRef<SVGSVGElement>;

  get fullName(): string {
    const p = this.patient;
    if (!p) return '—';
    const first = (p.firstName ?? '').trim();
    const last = (p.lastName ?? '').trim();
    return [first, last].filter(Boolean).join(' ') || '—';
  }

  get barcodeValue(): string {
    const p = this.patient;
    return (p?.barcodeValue ?? p?.accountNumber ?? p?.patientId ?? '').trim();
  }

  ngAfterViewInit(): void {
    this.renderBarcode();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['patient']) {
      setTimeout(() => this.renderBarcode(), 0);
    }
  }

  private renderBarcode(): void {
    const val = this.barcodeValue;
    const el = this.barcodeEl?.nativeElement;
    if (!el || !val) return;
    try {
      (JsBarcode as (el: SVGElement, val: string, opts?: object) => void)(el, val, {
        width: 1.2,
        height: 28,
        displayValue: true,
        fontSize: 10,
        margin: 0
      });
    } catch {
      el.innerHTML = val;
    }
  }

  safe(value: string | undefined | null): string {
    return value != null && String(value).trim() !== '' ? String(value).trim() : '—';
  }
}
